const { uidispatcherInternal } = await import("uidispatcher_api/UidispatcherApiModule");
const LoginStore = uidispatcherInternal.LoginStore;
export default LoginStore;
